import { Box, BoxProps, styled } from '@mui/material';
import { ColorOptions } from '@synergy/theme-next';
import { ReactElement } from 'react';

type Variants = 'small' | 'medium';

interface OuterDivProps extends BoxProps {
    background: ColorOptions;
    variant: Variants;
    hasSkew: boolean;
}

const OuterDiv = styled(Box, {
    shouldForwardProp: prop => prop !== 'background' && prop !== 'variant' && prop !== 'hasSkew',
})<OuterDivProps>(({ theme, background, variant, hasSkew }) => ({
    ...theme.typography['statusLabel'],
    display: 'inline-flex',
    alignItems: 'center',
    height: theme.spacing(2.75),
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(0.75),

    ...(background !== 'inherit' && {
        color: theme.palette[background].contrastText,
        backgroundColor: theme.palette[background].main,
        ...(hasSkew && {
            background: `linear-gradient(110deg, ${theme.palette[background].main} calc(100% - 10px), transparent calc(100% - 9px))`,
        }),
    }),
    ...(variant === 'medium' && {
        height: theme.spacing(3.5),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    }),
    ...(hasSkew && {
        paddingRight: theme.spacing(2.75),
    }),
}));

export interface PoolActionLabelProps extends BoxProps {
    color?: ColorOptions;
    variant?: Variants;
    hasSkew?: boolean;
}

export const PoolActionLabel = (props: PoolActionLabelProps): ReactElement => {
    const { color = 'primary', variant = 'medium', hasSkew = true } = props;

    return <OuterDiv {...props} background={color} variant={variant} hasSkew={hasSkew} />;
};
